export const config = {
    apiKey: "AIzaSyA5dEUdT_Ntty6Q00xNo2pJdgpc7Ezk4NI",
    authDomain: "powermantra.firebaseapp.com",
    databaseURL: "https://powermantra-default-rtdb.firebaseio.com",
    projectId: "powermantra",
    storageBucket: "powermantra.appspot.com",
    messagingSenderId: "202480180635",
    appId: "1:202480180635:web:82401bba64b4a27b67553e"
};
